import {
  ADMIN_ROLE,
  CLIENT_ROLE,
  CRUPIER_ROLE,
  OPERATOR_ROLE,
  SUPERADMIN_ROLE,
} from '../../helpers/CONSTANTS';

export const onlySuperAdmin = [SUPERADMIN_ROLE];
export const onlyAdminOrSuperAdmin = [ADMIN_ROLE, SUPERADMIN_ROLE];
export const onlyAdmins = [ADMIN_ROLE, SUPERADMIN_ROLE, 'ADMIN_OPERATOR', 'PARTNER'];
export const onlyAdmin = [ADMIN_ROLE, SUPERADMIN_ROLE];
export const operatorPass = [OPERATOR_ROLE];
export const clientPass = [CLIENT_ROLE];
export const crupierPass = [CRUPIER_ROLE];
export const onlyAdminClient = [SUPERADMIN_ROLE, ADMIN_ROLE, CLIENT_ROLE];
export const onlyAdminOperator = [
  SUPERADMIN_ROLE,
  ADMIN_ROLE,
  OPERATOR_ROLE,
];
